export const eventYears = [
  {
    year: '2026',
    items: [
      {
        route: '/Events/2026/1',
        title:
          'Call for Nominations - IGU Outstanding Achievement Award and Excellent Young Scholar Award in Modeling Geographical Systems (2026)',
        summary:
          'The IGU Outstanding Achievement Award and Excellent Young Scholar Award in Modeling Geographical Systems (OAA 2026 and YSA 2026) are receiving nominations. The awards recognize long and meritorious contributions to geographic modeling research and significant early-career academic contributions.'
      }
    ]
  },
  {
    year: '2025',
    items: [
      {
        route: '/Events/2025/3',
        title: 'Announcement of IGU MGSC Awards 2025',
        summary:
          'After careful consideration by the awards committee, the IGU MGSC Awards 2025 were announced. One Outstanding Achievement Award winner and two Excellent Young Scholar Award winners were selected.'
      },
      {
        route: '/Events/2025/2',
        title:
          'Call for Nominations - IGU Outstanding Achievement Award and Excellent Young Scholar Award in Modeling Geographical Systems (2025)',
        summary:
          'The IGU Outstanding Achievement Award and Excellent Young Scholar Award in Modeling Geographical Systems (OAA 2025 and YSA 2025) are receiving nominations to recognize distinguished and early-career contributions to geographic modeling research.'
      },
      {
        route: '/Events/2025/1',
        title: 'The fifth training course on geographical analysis models in China',
        summary:
          'The fifth training course on geographic analysis models in China was successfully held from August 9 to 16, 2025. IGU MGSC joined several academic organizations in supporting the course.'
      }
    ]
  },
  {
    year: '2024',
    items: [
      {
        route: '/Events/2024/6',
        title:
          'The 3rd international workshop on geographic modeling and simulation was successfully held',
        summary:
          'The 3rd International Workshop on Geographic Modeling and Simulation was successfully held at Nanjing Normal University from October 26 to 27, 2024, under the theme “Modeling and Simulation for a Sustainable World”.'
      },
      {
        route: '/Events/2024/5',
        title:
          'IGU MGCS participated in the 35th International Geographical Congress (IGC 2024)',
        summary:
          'IGU MGSC organized a parallel session on Modeling and Simulating Geographical Systems in the Big Data Era during the 35th International Geographical Congress in Dublin, Ireland.'
      },
      {
        route: '/Events/2024/4',
        title: 'Announcement of IGU MGSC Awards 2024',
        summary:
          'After careful consideration by the awards committee, the IGU MGSC Awards 2024 were announced to recognize outstanding academic contributions in geographic modeling research.'
      },
      {
        route: '/Events/2024/3',
        title: 'The fourth training course on geographical analysis models in China',
        summary:
          'The fourth training course on geographic analysis models in China was successfully held from August 1 to 8, 2024, with IGU MGSC participating as a co-organizer.'
      },
      {
        route: '/Events/2024/2',
        title:
          'Call for Nominations - IGU Outstanding Achievement Award and Excellent Young Scholar Award in Modeling Geographical Systems (2024)',
        summary:
          'Nominations opened for the IGU Outstanding Achievement Award and Excellent Young Scholar Award in Modeling Geographical Systems 2024, recognizing distinguished and early-career research contributions.'
      },
      {
        route: '/Events/2024/1',
        title:
          'The 3rd International Workshop on Geographic Modeling and Simulation: Modeling and Simulation for A Sustainable World',
        summary:
          'The workshop focuses on geographic modeling and simulation theories, approaches, technologies and solutions that support interdisciplinary research and sustainable development.'
      }
    ]
  },
  {
    year: '2023',
    items: [
      {
        route: '/Events/2023/3',
        title:
          'Call for abstracts | IGC 2024 Modeling and Simulating Geographical Systems in the Big Data Era session',
        summary:
          'IGU MGSC invited abstracts for its Modeling and Simulating Geographical Systems in the Big Data Era session at the 35th International Geographical Congress in Dublin.'
      },
      {
        route: '/Events/2023/2',
        title: 'Announcement of IGU MGSC Awards 2023',
        summary:
          'After careful consideration by the awards committee, the IGU MGSC Awards 2023 were announced to recognize outstanding contributions in geographic modeling research.'
      },
      {
        route: '/Events/2023/1',
        title: 'Minutes of Modeling Geographical Systems Commission (MGSC) board meeting',
        summary:
          'The IGU MGSC board held its 2022 annual meeting online on January 10, 2023, reviewing membership, recent events, publications and plans for future activities.'
      }
    ]
  },
  {
    year: '2022',
    items: [
      {
        route: '/Events/2022/5',
        title:
          '2022 Annual Academic Conference of the Geographic Modeling and Geographic Information Analysis Committee of the Chinese Geographical Society',
        summary:
          'The annual academic conference was held in Nanjing from September 17 to 18, 2022, exploring geographic information modeling and simulation in the new era of geography.'
      },
      {
        route: '/Events/2022/3',
        title: 'The second training course on Chinese geographical analysis models',
        summary:
          'The second training course on Chinese geographic analysis models was successfully held from July 30 to August 6, 2022, with IGU MGSC supporting the course as a co-organizer.'
      },
      {
        route: '/Events/2022/4',
        title:
          'The session of Geographic information modelling and simulation in the era of big data in IGU Paris 2022',
        summary:
          'IGU MGSC organized a virtual session on geographic information modelling and simulation in the era of big data during the IGU centennial congress in Paris.'
      },
      {
        route: '/Events/2022/2',
        title: 'Announcement of IGU MGSC Awards 2022',
        summary:
          'The IGU MGSC Awards 2022 were announced, recognizing one Outstanding Achievement Award winner and two Excellent Young Scholar Award winners.'
      },
      {
        route: '/Events/2022/1',
        title:
          'Call for Nominations - IGU Outstanding Achievement Award and Excellent Young Scholar Award in Modeling Geographical Systems (2022)',
        summary:
          'Nominations opened for the IGU Outstanding Achievement Award and Excellent Young Scholar Award in Modeling Geographical Systems 2022.'
      }
    ]
  },
  {
    year: '2021',
    items: [
      {
        route: '/Events/2021/6',
        title:
          'Minutes of the second board meeting of Modeling Geographical Systems Commission (MGSC)',
        summary:
          'The second IGU MGSC board meeting was held online on September 20, 2021, covering membership progress, important events, special issues and future activities.'
      },
      {
        route: '/Events/2021/5',
        title:
          'IGU 19th International Conference on Spatial Data Handling and Geographic Intelligence',
        summary:
          'The 19th International Conference on Spatial Data Handling and Geographic Intelligence was held on August 13 and 14, 2021, co-organized by two IGU commissions.'
      },
      {
        route: '/Events/2021/4',
        title: 'The first training course on Chinese geographical analysis models',
        summary:
          'The first training course on Chinese geographic analysis models was successfully held from August 9 to 16, 2021, with IGU MGSC participating as a co-organizer.'
      },
      {
        route: '/Events/2021/3',
        title:
          'Minutes of the first board meeting of Modeling Geographical Systems Commission (MGSC)',
        summary:
          'The first IGU MGSC board meeting was held online on January 27, 2021, discussing the commission website, awards, membership, objectives and planned events.'
      },
      {
        route: '/Events/2021/2',
        title:
          'The 2nd national forum on geographic modeling and simulation (and the launch ceremony of the training course on domestic geographical analysis models)',
        summary:
          'The second national forum on geographic modeling and simulation was held at Nanjing Normal University on January 16 and 17, 2021, using a combined onsite and online format.'
      },
      {
        route: '/Events/2021/1',
        title:
          'Call for Abstracts | The session of Geographic information modelling and simulation in the era of big data in IGU Paris 2022',
        summary:
          'IGU MGSC called for abstracts for a virtual session on geographic information modelling and simulation in the era of big data at the IGU centennial congress in Paris.'
      }
    ]
  },
  {
    year: '2020',
    items: [
      {
        route: '/Events/2020/1',
        title:
          'The general election of Modeling Geographical Systems Commission (MGSC) of International Geographical Union (IGU)',
        summary:
          'The general election of IGU MGSC was successfully completed, selecting the commission chair, secretary-general, steering committee members and honorary advisory members.'
      }
    ]
  }
];

export const latestNews = eventYears.reduce((items, group) => {
  return items.concat(
    group.items.map(item => ({
      ...item,
      year: group.year
    }))
  );
}, []);
